import { useApiClient } from '../../hooks/useApiClient';
import { ChangelogItemType } from '../../types/Changelog/ChangelogItemType.type';

export const useChangelogItemTypeApi = () => {
  const apiClient = useApiClient();

  return {
    getChangelogItemTypes: (): Promise<ChangelogItemType[]> => apiClient(`/changelog_item_types/`),
  };
};
